import { Toaster as ToasterBase } from "react-hot-toast";
import Style from "./toaster.module.scss";
import clsx from "clsx";
import checkIcon from "./check.svg";
export function Toaster(props: {}) {
  return (
    <ToasterBase
      toastOptions={{
        className: Style.Toast,
        position: "top-center",
        success: {
          icon: (
            <div className={Style.Icon}>
              <img src={checkIcon} alt="✓" />
            </div>
          ),
          className: clsx(Style.Toast, Style.Success),
          duration: 6000,
        },
      }}
    />
  );
}
